import BookingCircleIcon from "../../../assets/icons/bookingCircleImage.png";
import BookingMainImage from "../../../assets/icons/bookingName.png";
import WTCircleIcon from "../../../assets/icons/wtcircleicon.png";
import WTMainImage from "../../../assets/icons/wtmainImage.png";
import TripCircleIcon from "../../../assets/icons/tripCircle.png";
import TripMainImage from "../../../assets/icons/tripMain.png";
import MozioCircleImage from "../../../assets/icons/mozio_circle.png";
import MozioMainImage from "../../../assets/icons/mozio_logo.png";

export const integrationData = [
  {
    id: 1,
    circleIcon: BookingCircleIcon,
    mainImage: BookingMainImage,
    value: "Booking.com",
    connectionStatus: false,
  },
  {
    id: 2,
    circleIcon: WTCircleIcon,
    mainImage: WTMainImage,
    value: "WorldTransfer.com",
    connectionStatus: false,
  },
  {
    id: 3,
    circleIcon: TripCircleIcon,
    mainImage: TripMainImage,
    value: "Trip.com",
    connectionStatus: false,
  },
  {
    id: 4,
    circleIcon: MozioCircleImage,
    mainImage: MozioMainImage,
    value: "Mozio",
    connectionStatus: false,
  },
];

export const integrationPermission = [
  {
    integrationType: "Booking.com",
    permission: ["Get Booking", "Rate Module"],
  },
  {
    integrationType: "WorldTransfer.com",
    permission: ["Get Booking"],
  },
  {
    integrationType: "Trip.com",
    permission: ["Get Booking", "Rate Module"],
  },
  {
    integrationType: "Mozio",
    permission: ["Rate Module"],
  },
];
